import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import useCharge from 'features/Charge/useCharge';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { FastField, Field, Formik } from 'formik';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown, {
  KTBSDropdownDirections,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import ImageView from 'general/components/quybka/Images/ImageView';
import TagifyInput from 'general/components/quybka/Inputs/TagifyInput';
import Bingmap from 'general/components/quybka/Maps/Bingmap';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

ChargeStationAddView.propTypes = {
  chargeStationId: PropTypes.string,
};

function ChargeStationAddView({ chargeStationId }) {
  // MARK: ---- PROPERTIES ----
  const [readyToValidData, setReadyToValidData] = useState(false);
  const configServices = useSelector((state) => state.app.appConfig?.services ?? []);
  const configServiceCodes = useMemo(() => {
    return _.join(
      configServices?.map((item) => item.name),
      ','
    );
  }, [configServices]);
  const editMode = !!chargeStationId;
  const [allFiles, setAllFiles] = useState([]);
  const [chargeStationDetail, setChargeStationDetail] = useState();
  useEffect(() => {
    if (!chargeStationId) return;
    ChargeHelper.API.getChargeStationDetail(chargeStationId).then((response) => {
      setChargeStationDetail(response);
      setAllFiles(response?.additionalImages);
    });
  }, [chargeStationId]);
  const router = useRouter();
  const refFooter = useRef();
  const appConfig = useAppConfig();
  const [loading, setLoading] = useState(false);
  const footer = KTUtil.getById('kt_footer');
  const footerHeight = footer?.offsetHeight ?? 0;
  const user = useSelector((state) => state.auth.user);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const refFormik = useRef(null);
  const initialFormikValues = useMemo(() => {
    return {
      areaId: chargeStationDetail?.areaId ?? null,
      monthlyPremiseCost: chargeStationDetail?.monthlyPremiseCost ?? 0,
      energyCost: chargeStationDetail?.energyCost ?? 0,
      currency: 'VNĐ',
      status: chargeStationDetail?.status ?? ChargeConstants.ChargeStationStatus.NORMAL,
      name: chargeStationDetail?.name ?? '',
      description: chargeStationDetail?.description ?? '',
      address: chargeStationDetail?.address ?? '',
      phone: chargeStationDetail?.phone ?? '',
      operatorId: 1,
      agencyId: chargeStationDetail?.agencyId ?? null,
      landlordId: chargeStationDetail?.landlordId ?? null,
      latitude: chargeStationDetail?.latitude ?? null,
      longitude: chargeStationDetail?.longitude ?? null,
      image: chargeStationDetail?.image ?? '',
      contactName: chargeStationDetail?.contactName ?? '',
      contactPhone: chargeStationDetail?.contactPhone ?? '',
      isAgencyPayEnergyCost: chargeStationDetail?.isAgencyPayEnergyCost?.toString() ?? '0',
      inputPricingMode: chargeStationDetail?.inputPricingMode ?? ChargeHelper.Data.chargeStationPricingModeOptions[0].value,
      inputFlatPrice: chargeStationDetail?.inputFlatPrice ?? 0,
      inputNormalPrice: chargeStationDetail?.inputNormalPrice ?? 0,
      inputPeakPrice: chargeStationDetail?.inputPeakPrice ?? 0,
      inputOffPeakPrice: chargeStationDetail?.inputOffPeakPrice ?? 0,
      inputTieredPrice: [
        { upto: 50, price: Number(chargeStationDetail?.inputTieredPrice?.[0]?.price) || 0 },
        { upto: 100, price: Number(chargeStationDetail?.inputTieredPrice?.[1]?.price) || 0 },
        { upto: 200, price: Number(chargeStationDetail?.inputTieredPrice?.[2]?.price) || 0 },
        { upto: 300, price: Number(chargeStationDetail?.inputTieredPrice?.[3]?.price) || 0 },
        { upto: 400, price: Number(chargeStationDetail?.inputTieredPrice?.[4]?.price) || 0 },
        { upto: 999999999, price: Number(chargeStationDetail?.inputTieredPrice?.[5]?.price) || 0 },
      ],
      vehicleTypes: chargeStationDetail?.vehicleTypes[0] ?? ChargeConstants.VehicleType.CAR,
      premiseId: chargeStationDetail?.premiseId ?? '',
    };
  }, [chargeStationDetail]);
  useEffect(() => {
    if (
      Utils.isValid(chargeStationDetail?.latitude) &&
      Utils.isValid(chargeStationDetail?.longitude)
    ) {
      setCoordinates(`${chargeStationDetail?.latitude}, ${chargeStationDetail?.longitude}`);
    }
  }, [chargeStationDetail]);
  const validationSchema = ChargeHelper.ValidationSchema.chargeStation;
  const { managementObjectOptions } = useCharge();
  const [selectedManagementObject, setSelectedManagementObject] = useState(AppConstants.userRole.admin);
  const [selectedAgency, setSelectedAgency] = useState();
  const [vehicleType, setVehicleType] = useState(ChargeConstants.VehicleType.CAR);
  const [selectedPremise, setSelectedPremise] = useState();

  const landlordInfoNeedToPurchase = useRef([]);
  const [landlordReadyToPurchase, setLandlordReadyToPurchase] = useState(true);
  useEffect(() => {
    if (selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR) return;
    const arrInfoNeedToPurchase = AgencyHelper.Utils.checkAgencyEnoughInfoToPurchase(
      selectedAgency?.item
    );
    const isReady = _.isEmpty(arrInfoNeedToPurchase);
    landlordInfoNeedToPurchase.current = arrInfoNeedToPurchase;
    setLandlordReadyToPurchase(isReady);
    if (!isReady) {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogInfo} />}
          title={`Chưa có đủ thông tin chủ mặt bằng`}
          contentEl={
            <>
              Vui lòng cập nhật đầy đủ thông tin của chủ mặt bằng {' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {selectedAgency?.name}
              </span>{' '}
              để có thể tạo đơn hàng. Thông tin còn thiếu:{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {landlordInfoNeedToPurchase.current?.join(', ')}
              </span>
            </>
          }
          cancelButtonText="Bỏ qua"
          confirmButtonText={'Cập nhật thông tin'}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={() => {
            AppCustomDialogHelper.hide();
            AgencyHelper.Navigation.navigateToAgencyEdit(null, selectedAgency?.item);
          }}
        />,
        'md',
        false,
        true
      );
    }
  }, [selectedAgency, selectedManagementObject]);

  const dropdownAgencyEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="agencyId"
        name="agencyId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
              ${(!selectedAgency && readyToValidData || !landlordReadyToPurchase) ? 'button-invalid' : ''}
              `}
            type="button"
          >
            {selectedAgency
              ? selectedAgency?.name
              : selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                ? 'Chọn nhà đầu tư'
                : 'Chọn chủ mặt bằng'}
          </button>
        }
        selectedValue={selectedAgency}
        subTitleType="email"
        dropdownMenuItems={[]}
        getSubItems={async (item) => {
          return AgencyHelper.API.requestGetAgencyList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
            status: ChargeConstants.ChargeStationStatus.NORMAL,
            role:
              selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                ? 'INVESTOR'
                : 'LANDLORD',
          }).then((data) => {
            return {
              values: data.agencies?.map((row) => ({
                id: row?.agencyId,
                name: row?.name,
                item: row,
                email: row?.email,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedAgency(value);
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        disabled={selectedManagementObject === ''}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'LANDLORD',
          role: 'LANDLORD',
        }}
        defaultItem={null}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedAgency(null);
            })}
          </div>
        }
      />
    );
  }, [selectedAgency, selectedManagementObject, user, readyToValidData, landlordReadyToPurchase]);
  const dropdownPremiseEl = useMemo(() => {
    return (
      <CustomDropdown2
        ignoreConfirmClick={true}
        name="premiseId"
        id="premiseId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                        ${(!selectedAgency || selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR) ? 'dropdown-disabled' : ''}
                        ${!selectedPremise?.id && selectedManagementObject !== AgencyConstants.AgencyRole.INVESTOR && readyToValidData ? 'button-invalid' : ''}`}
            type="button"
          >
            {selectedPremise?.name?.length ? selectedPremise?.name : 'Chọn mặt bằng'}
          </button>
        }
        selectedValue={selectedPremise}
        subTitleType="address"
        dropdownMenuItems={[]}
        getSubItems={async (item) => {
          try {
            const param = {
              role: item?.role,
              page: item?.page || 0,
              limit: 10,
              q: item?.q || '',
              landlordId: selectedAgency?.id
            };
            return await AgencyHelper.API.requestGetPremiseList(param).then(
              (data) => {
                return {
                  values: data.premises?.map((row) => ({
                    id: row?.premiseId,
                    name: row?.name,
                    item: row,
                    address: ChargeHelper.Utils.getChargeStationFullAddress(row),
                  })),
                  total: data?.total,
                };
              }
            );
          } catch (error) {
            console.error('Error fetching premise list:', error);
            return { values: [], total: 0 };
          }
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedPremise({
            id: value?.id,
            name: value?.item?.name,
            type: value?.item?.type,
            floorArea: value?.item?.floorArea,
            vehicleTypes: value?.item?.vehicleTypes?.join(','),
            rentingType: value?.item?.rentingType,
            parkingSlots: value?.item?.parkingSlots,
            rentalForm: value?.item?.rentalForm,
            areaId: value?.item?.areaId,
            address: value?.item?.address,
            description: value?.item?.description,
            monthlyRent: value?.item?.monthlyRent,
            slotRent: value?.item?.slotRent,
          });
        }}
        isDropdownForm={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        disabled={(!selectedAgency || selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR)}
        defaultValue={{
          name: 'Chủ mặt bằng',
          role: AgencyConstants.AgencyRole.LANDLORD,
        }}
        dependItem={selectedAgency}
      />
    )
  }, [selectedAgency, selectedPremise, selectedManagementObject, readyToValidData])

  useEffect(() => {
    if (chargeStationDetail) {
      if (chargeStationDetail?.agencyId) {
        if (chargeStationDetail?.agencyId === appConfig.groupAgencyId) {
          setSelectedManagementObject(AgencyConstants.AgencyRole.LANDLORD);
          if (chargeStationDetail?.landlordId) {
            AgencyHelper.API.requestAgencyDetail(chargeStationDetail?.landlordId).then((agency) => {
              setSelectedAgency({
                id: agency?.agencyId,
                name: agency?.name,
                item: agency,
              });
            });
          }
        } else {
          setSelectedManagementObject(AgencyConstants.AgencyRole.INVESTOR);
          AgencyHelper.API.requestAgencyDetail(chargeStationDetail?.agencyId).then((agency) => {
            setSelectedAgency({
              id: agency?.agencyId,
              name: agency?.name,
              item: agency,
            });
          });
        }
      } else {
        setSelectedManagementObject(AppConstants.userRole.admin);
        if (chargeStationDetail?.landlordId) {
          AgencyHelper.API.requestAgencyDetail(chargeStationDetail?.landlordId).then((agency) => {
            setSelectedAgency({
              id: agency?.agencyId,
              name: agency?.name,
              item: agency,
            });
          });
        }
      }
    }
  }, [chargeStationDetail]);

  useEffect(() => {
    if (chargeStationDetail) {
      if (chargeStationDetail?.premiseId) {
        AgencyHelper.API.requestGetPremiseDetail(chargeStationDetail?.premiseId).then((data) => {
          setSelectedPremise({
            id: data?.premiseId,
            name: data?.name,
          });
        });
      }
    }
  }, [chargeStationDetail]);
  const { operatorList, operatorOptions } = useAgency();
  const [selectedOperator, setSelectedOperator] = useState('');
  useEffect(() => {
    if (!_.isEmpty(operatorList)) {
      setSelectedOperator(operatorList[0].operatorId);
    }
  }, [operatorList]);
  // khu vuc
  const areaTree = useSelector((state) => state.app.areaTree);
  const areaProvinceList = useMemo(() => {
    return ChargeHelper.Utils.getAreaListByType([areaTree], 'P');
  }, [areaTree]);
  const areaProvinceOptions = useMemo(() => {
    return _.map(areaProvinceList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaProvinceList]);
  const [selectedAreaProvince, setSelectedAreaProvince] = useState();
  const areaDistrictList = useMemo(() => {
    if (!selectedAreaProvince) return [];
    return ChargeHelper.Utils.getSubAreaListByParentId([areaTree], selectedAreaProvince?.areaId);
  }, [areaTree, selectedAreaProvince]);
  const areaDistrictOptions = useMemo(() => {
    return _.map(areaDistrictList, (item) => {
      return {
        name: item.name,
        value: item.areaId,
      };
    });
  }, [areaDistrictList]);
  const [selectedAreaDistrict, setSelectedAreaDistrict] = useState();
  useEffect(() => {
    if (chargeStationDetail) {
      const areaId = chargeStationDetail.areaId;
      const area = ChargeHelper.Utils.getAreaById([areaTree], areaId);
      const parentAreaId = area?.parentId;
      const parentArea = ChargeHelper.Utils.getAreaById([areaTree], parentAreaId);
      if (area?.typeCode === 'W') {
        setSelectedAreaDistrict(area);
        if (parentArea?.typeCode === 'P') {
          setSelectedAreaProvince(parentArea);
        }
      } else if (area?.typeCode === 'P') {
        setSelectedAreaProvince(area);
      }
    }
  }, [chargeStationDetail, areaTree, refFormik]);
  const [imageSrc, setImageSrc] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [csServices, setCsServices] = useState([]);
  useEffect(() => {
    if (chargeStationDetail) {
      const services = _.filter(configServices, (item) =>
        _.includes(chargeStationDetail.services, item.serviceCode)
      );
      setCsServices(services.map((item) => item.name));
    }
  }, [chargeStationDetail, configServices]);
  const bingmapEl = useMemo(() => {
    return (
      <Bingmap
        name={selectedAreaDistrict?.areaId}
        latitude={selectedAreaDistrict?.latitude}
        longitude={selectedAreaDistrict?.longitude}
      />
    );
  }, [selectedAreaDistrict]);
  // danh sach tai khoan dien luc
  const [energyAccountList, setEnergyAccountList] = useState([
    {
      energyAccountId: '',
      username: '',
      password: '',
      stationId: '',
      evnCustomerId: '',
      status: ChargeConstants.EnergyAccountStatus.PENDING,
    },
  ]);
  useEffect(() => {
    setEnergyAccountList(chargeStationDetail?.energyAccounts?.length
      ? chargeStationDetail?.energyAccounts
      : [{
        energyAccountId: '',
        username: '',
        password: '',
        stationId: '',
        evnCustomerId: '',
        status: ChargeConstants.EnergyAccountStatus.PENDING,
      }]);
  }, [chargeStationDetail]);

  const [coordinates, setCoordinates] = useState();
  // useEffect(() => {
  //   if (Utils.isValid(selectedAreaDistrict)) {
  //     const lat = selectedAreaDistrict?.latitude;
  //     const lng = selectedAreaDistrict?.longitude;
  //     setCoordinates(`${lat}, ${lng}`);
  //   } else if (Utils.isValid(selectedAreaProvince)) {
  //     const lat = selectedAreaProvince?.latitude;
  //     const lng = selectedAreaProvince?.longitude;
  //     setCoordinates(`${lat}, ${lng}`);
  //   }
  // }, [selectedAreaProvince, selectedAreaDistrict]);
  useEffect(() => {
    if (coordinates) {
      const lat = coordinates.split(',')[0];
      const lng = coordinates.split(',')[1];
      refFormik.current.setFieldValue('latitude', lat);
      refFormik.current.setFieldValue('longitude', lng);
    }
  }, [coordinates, refFormik]);

  // MARK: ---- METHODS ----
  const handleSubmitEnergyAccounts = async (stationId) => {
    const oldEnergyAccountIds =
      chargeStationDetail?.energyAccounts?.map((item) => item.energyAccountId) ?? [];
    const addEnergyAccountList = _.filter(
      energyAccountList,
      (item) => !oldEnergyAccountIds.includes(item.energyAccountId)
    );
    const updateEnergyAccountList = _.filter(energyAccountList, (item) =>
      oldEnergyAccountIds.includes(item.energyAccountId)
    );
    const deleteEnergyAccountList = _.filter(
      chargeStationDetail?.energyAccounts,
      (item) => !_.find(energyAccountList, { energyAccountId: item.energyAccountId })
    );
    console.log({ addEnergyAccountList, updateEnergyAccountList, deleteEnergyAccountList });
    // them moi
    addEnergyAccountList.forEach(async (item) => {
      let param = _.omit(item, 'energyAccountId');
      param.stationId = stationId;
      if (isAdmin) param.status = ChargeConstants.EnergyAccountStatus.VALIDATED;
      try {
        await ChargeHelper.API.requestAddEnergyAccount(param);
      } catch (error) { }
    });
    // cap nhat
    updateEnergyAccountList.forEach(async (item) => {
      const id = item.energyAccountId;
      let param = _.omit(item, 'energyAccountId');
      param.stationId = stationId;
      try {
        await ChargeHelper.API.requestUpdateEnergyAccount(id, param);
      } catch (error) { }
    });
    // xoa
    deleteEnergyAccountList.forEach(async (item) => {
      const id = item.energyAccountId;
      try {
        await ChargeHelper.API.requestDeleteEnergyAccount(id);
      } catch (error) { }
    });
  };

  const handleUploadFile = async () => {
    const newImagePaths = [];
    for (let index = 0; index < allFiles?.length; index++) {
      const image = allFiles[index];
      if (image instanceof File) {
        const res = await miscHelper.callApiUploadFile(image);
        newImagePaths.push(res[0].relativePath);
      } else if (!!image) {
        newImagePaths.push(image);
      }
    }
    return newImagePaths;
  };

  const handleSubmit = async (values) => {
    if (!landlordReadyToPurchase && selectedManagementObject !== AgencyConstants.AgencyRole.INVESTOR) {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogInfo} />}
          title={`Chưa có đủ thông tin chủ mặt bằng`}
          contentEl={
            <>
              Vui lòng cập nhật đầy đủ thông tin của chủ mặt bằng {' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {selectedAgency?.name}
              </span>{' '}
              để có thể tạo đơn hàng. Thông tin còn thiếu:{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {landlordInfoNeedToPurchase.current?.join(', ')}
              </span>
            </>
          }
          cancelButtonText="Bỏ qua"
          confirmButtonText={'Cập nhật thông tin'}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={() => {
            AppCustomDialogHelper.hide();
            AgencyHelper.Navigation.navigateToAgencyEdit(null, selectedAgency?.item);
          }}
        />,
        'md',
        false,
        true
      );
      return;
    }

    if (!Utils.isValid(coordinates) || !coordinates?.match(AppConfigs.regex.coordinate)) {
      ToastHelper.showError('Toạ độ không hợp lệ');
      return;
    }

    // kiem tra tai khoan dien luc hop le
    if (
      _.some(
        energyAccountList,
        (item) =>
          _.isEmpty(item.evnCustomerId) || _.isEmpty(item.username) || _.isEmpty(item.password)
      )
    ) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin tài khoản điện lực');
      return;
    }

    if (selectedManagementObject !== '' && !selectedAgency) {
      ToastHelper.showError(
        selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
          ? 'Vui lòng chọn nhà đầu tư nhượng quyền'
          : 'Vui lòng chọn chủ mặt bằng'
      );
      return;
    }

    if ((selectedManagementObject !== AgencyConstants.AgencyRole.INVESTOR) &&
      selectedAgency && !selectedPremise
    ) {
      ToastHelper.showError('Vui lòng chọn mã mặt bằng');
      return;
    }

    let param = { ...Utils.trimAll(values) };
    // console.log({ param });
    // return;
    param.areaId = selectedAreaDistrict?.areaId;
    // delete param.image;
    if (imageSrc) {
      const res = await miscHelper.callApiUploadFile(imageSrc);
      if (_.isArray(res) && res.length > 0) {
        param.image = res[0].relativePath;
      }
    }
    // dich vu di kem
    const services = _.filter(configServices, (item) => _.includes(csServices, item.name));
    param.services = services.map((item) => item.serviceCode);
    param = _.omitBy(param, _.isNil);
    if (selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR) {
      param.landlordId = null;
      param.agencyId = selectedAgency?.id;
    } else if (selectedManagementObject === AgencyConstants.AgencyRole.LANDLORD) {
      param.agencyId = appConfig?.groupAgencyId;
      param.landlordId = selectedAgency?.id;
    } else {
      param.agencyId = null;
      param.landlordId = selectedAgency?.id;
    }
    if (param?.image === '') {
      param.image = null;
    }
    if (values.inputPricingMode === 'HOURS') {
      param.inputTieredPrice = [];
      param.inputFlatPrice = 0;
    } else if (values.inputPricingMode === 'TIERED') {
      param.inputFlatPrice = 0;
      param.inputNormalPrice = 0;
      param.inputPeakPrice = 0;
      param.inputOffPeakPrice = 0;
    } else if (values.inputPricingMode === 'FLAT') {
      param.inputTieredPrice = [];
      param.inputNormalPrice = 0;
      param.inputPeakPrice = 0;
      param.inputOffPeakPrice = 0;
    }
    param.vehicleTypes = [param.vehicleTypes]

    if (allFiles?.length > 0) {
      const imagePath = await handleUploadFile();
      param.additionalImages = imagePath;
    }

    if (selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR) {
      param.premiseId = null;
    } else {
      param.premiseId = selectedPremise?.id;
    }

    console.log({ param });
    // return;
    setLoading(true);
    try {
      if (!editMode) {
        // them moi
        const res = await ChargeHelper.API.requestAddChargeStation(param);
        if (res && _.isObject(res)) {
          console.log({ res });
          const id = res?.stationId;
          if (id) {
            // them tai khoan dien luc
            handleSubmitEnergyAccounts(id);
          }

          ToastHelper.showSuccess('Thêm trạm sạc thành công');
          router.navigate(-1);
        } else if (_.isString(res)) {
          ToastHelper.showError(res);
        }
      } else {
        // cap nhat
        const res = await ChargeHelper.API.requestUpdateChargeStation(chargeStationId, param);
        if (res) {
          // cap nhat tai khoan dien luc
          handleSubmitEnergyAccounts(chargeStationId);
          ToastHelper.showSuccess('Cập nhật trạm sạc thành công');
          router.navigate(-1);
        }
      }
    } catch (error) {
      if (_.isString(error)) ToastHelper.showError(error);
    }

    setLoading(false);
  };

  const handleFilesChanged = (e) => {
    const files = e.target.files;
    const tmpSelectedFiles = [...selectedFiles];
    tmpSelectedFiles.push(...files);
    setSelectedFiles(tmpSelectedFiles);
    setAllFiles(tmpSelectedFiles);
  };

  const handleRemoveFile = (file) => {
    if (file instanceof File) {
      const tmpFiles = selectedFiles.filter((item) => item.lastModified !== file?.lastModified);
      setSelectedFiles(tmpFiles);
    }

    let newAllFiles = [...allFiles];
    if (typeof file === 'string') {
      newAllFiles = _.filter(allFiles, (item) => item !== file);
    }
    if (file instanceof File) {
      newAllFiles = _.filter(allFiles, (item) => item.lastModified !== file?.lastModified);
    }
    setAllFiles(newAllFiles);
  };

  return (
    <div>
      <div
        className="px-4 my-4"
        style={{
          paddingBottom: `calc(${refFooter.current?.offsetHeight ?? 0}px - ${footerHeight}px)`,
        }}
      >
        {UIHelper.buildCard(
          <div>
            {UIHelper.buildCardHeader(
              !editMode ? 'Thêm trạm sạc' : 'Sửa trạm sạc',
              true,
              null,
              true
            )}
            {/* content */}
            <Formik
              initialValues={initialFormikValues}
              validationSchema={validationSchema}
              enableReinitialize={true}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {(formikProps) => {
                refFormik.current = formikProps;
                return (
                  <div className="pt-4">
                    {/* thong tin tram sac */}
                    <div
                      className="row m-0 p-0 px-2"
                      style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                      }}
                    >
                      <div className="col-lg-4 mb-4 px-2">
                        <div className="w-120px">
                          {UIHelper.buildFormLabel('Ảnh trạm sạc')}
                          <FastField name="image">
                            {({ field, form, meta }) => (
                              <KTImageInput
                                fullWidth={true}
                                aspectRatio={'1'}
                                name={field.name}
                                acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                editable={true}
                                value={Utils.getFullUrl(field.value)}
                                defaultImage={
                                  AppResource.images.chargeConnectorTypes.imgChargeStationBgDefault
                                }
                                enableCheckValid={false}
                                onSelectedFile={(file) => {
                                  setImageSrc(file);
                                  const imageUrl = URL.createObjectURL(file);
                                  form.setFieldValue(field.name, imageUrl);
                                }}
                                onRemovedFile={() => {
                                  setImageSrc(null);
                                  form.setFieldValue(field.name, '');
                                }}
                                isValid={_.isEmpty(meta.error)}
                                isTouched={meta.touched}
                                feedbackText={meta.error}
                              />
                            )}
                          </FastField>
                        </div>
                        {UIHelper.buildFormText('Định dạng: JPG, PNG, JPEG')}
                      </div>
                      <div className="col-lg-4 mb-4 px-2">
                        {/* ten tram sac */}
                        <div>
                          {UIHelper.buildFormLabel('Tên trạm sạc', true)}
                          <FastField name="name">
                            {({ field, form, meta }) => (
                              <KTFormInput
                                type={KTFormInputType.text}
                                placeholder="Nhập tên trạm sạc"
                                name={field.name}
                                value={field.value}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value);
                                }}
                                onBlur={() => {
                                  form.setFieldTouched(field.name, true);
                                }}
                                enableCheckValid={true}
                                isValid={_.isEmpty(meta.error)}
                                isTouched={meta.touched}
                                feedbackText={meta.error}
                              />
                            )}
                          </FastField>
                        </div>

                        {/* doi tuong quan ly */}
                        <div className="mt-4">
                          {UIHelper.buildFormLabel('Đối tượng quản lý', true)}
                          <KTBSDropdown
                            name="managementObject"
                            toggleElement={
                              <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                                type="button"
                              >
                                {_.find(
                                  managementObjectOptions,
                                  (item) => item.value === selectedManagementObject
                                )?.name ?? 'Nhà điều hành'}
                              </button>
                            }
                            selectedValue={selectedManagementObject}
                            dropdownMenuItems={managementObjectOptions}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                              setSelectedManagementObject(value);
                              formikProps.setFieldValue('agencyId', null);
                              formikProps.setFieldValue('landlordId', null);
                              setSelectedAgency(null);
                            }}
                            isDropdownForm={true}
                          />
                        </div>

                        {/* ma mat bang */}
                        <div className="mt-4">
                          {UIHelper.buildFormLabel('Mã mặt bằng', selectedManagementObject !== AgencyConstants.AgencyRole.INVESTOR)}
                          {dropdownPremiseEl}
                        </div>
                      </div>
                      <div className="col-lg-4 mb-4 px-2">
                        {/* nha dieu hanh */}
                        <div className="">
                          {UIHelper.buildFormLabel('Nhà điều hành', true)}
                          <KTBSDropdown
                            name="operator"
                            toggleElement={
                              <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                                type="button"
                              >
                                {
                                  _.find(operatorOptions, (item) => item.value === selectedOperator)
                                    ?.name
                                }
                              </button>
                            }
                            selectedValue={selectedOperator}
                            dropdownMenuItems={operatorOptions}
                            dropdownMenuClassName="overflow-auto w-100"
                            dropdownMenuStyle={{ maxHeight: '30vh' }}
                            onChange={(value) => {
                              setSelectedOperator(value);
                            }}
                            isDropdownForm={true}
                          />
                        </div>

                        {/* NĐT NQ hoac chu dat */}
                        <div className="mt-4">
                          {UIHelper.buildFormLabel(
                            selectedManagementObject === AgencyConstants.AgencyRole.INVESTOR
                              ? 'Nhà đầu tư NQ'
                              : 'Chủ mặt bằng',
                            selectedManagementObject !== ''
                          )}
                          {dropdownAgencyEl}
                        </div>

                        {/* loai phuong tien */}
                        <div className='mt-4'>
                          {UIHelper.buildFormLabel('Loại phương tiện', true)}
                          <FastField name="vehicleTypes">
                            {({ field, form, meta }) => (
                              <KTBSDropdown
                                name="vehicleTypes"
                                toggleElement={
                                  <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!field?.value && readyToValidData ? 'dropdown-disabled' : ''}`}
                                    type="button"
                                  >
                                    {_.find(
                                      ChargeHelper.Data.vehicleTypeOptions,
                                      (item) => item.value === field.value
                                    )?.name ?? 'Chọn loại phương tiện'}
                                  </button>
                                }
                                selectedValue={field.value}
                                dropdownMenuItems={ChargeHelper.Data.vehicleTypeOptions}
                                dropdownMenuClassName="overflow-auto w-100"
                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value);
                                }}
                                isDropdownForm={true}
                              />
                            )}
                          </FastField>
                        </div>
                      </div>
                    </div>

                    {/* thong tin lien he */}
                    <div
                      className=""
                      style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                      }}
                    >
                      {UIHelper.buildCardHeader('Thông tin liên hệ', false, null, true)}
                      <div className="row m-0 p-0 px-2">
                        {/* so dien thoai tram sac */}
                        <div className="col-lg-4 mb-4 px-2">
                          <div>
                            {UIHelper.buildFormLabel('Số điện thoại trạm sạc', true)}
                            <FastField name="phone">
                              {({ field, form, meta }) => (
                                <KTFormInput
                                  type={KTFormInputType.telephone}
                                  placeholder="Nhập số điện thoại trạm sạc"
                                  name={field.name}
                                  value={field.value}
                                  onChange={(value) => {
                                    form.setFieldValue(field.name, value);
                                  }}
                                  onBlur={() => {
                                    form.setFieldTouched(field.name, true);
                                  }}
                                  enableCheckValid={true}
                                  isValid={_.isEmpty(meta.error)}
                                  isTouched={meta.touched}
                                  feedbackText={meta.error}
                                />
                              )}
                            </FastField>
                          </div>
                        </div>
                        {/* ten nguoi quan ly tram sac */}
                        <div className="col-lg-4 mb-4 px-2">
                          <div>
                            {UIHelper.buildFormLabel('Tên người quản lý trạm sạc', true)}
                            <FastField name="contactName">
                              {({ field, form, meta }) => (
                                <KTFormInput
                                  type={KTFormInputType.text}
                                  placeholder="Nhập tên người quản lý trạm sạc"
                                  name={field.name}
                                  value={field.value}
                                  onChange={(value) => {
                                    form.setFieldValue(field.name, value);
                                  }}
                                  onBlur={() => {
                                    form.setFieldTouched(field.name, true);
                                  }}
                                  enableCheckValid={true}
                                  isValid={_.isEmpty(meta.error)}
                                  isTouched={meta.touched}
                                  feedbackText={meta.error}
                                />
                              )}
                            </FastField>
                          </div>
                        </div>
                        {/* sdt nguoi quan ly tram sac */}
                        <div className="col-lg-4 mb-4 px-2">
                          <div>
                            {UIHelper.buildFormLabel('Số điện thoại người quản lý trạm sạc', true)}
                            <FastField name="contactPhone">
                              {({ field, form, meta }) => (
                                <KTFormInput
                                  type={KTFormInputType.telephone}
                                  placeholder="Nhập số điện thoại người quản lý trạm sạc"
                                  name={field.name}
                                  value={field.value}
                                  onChange={(value) => {
                                    form.setFieldValue(field.name, value);
                                  }}
                                  onBlur={() => {
                                    form.setFieldTouched(field.name, true);
                                  }}
                                  enableCheckValid={true}
                                  isValid={_.isEmpty(meta.error)}
                                  isTouched={meta.touched}
                                  feedbackText={meta.error}
                                />
                              )}
                            </FastField>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* thong tin khac */}
                    <div
                      className=""
                      style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                      }}
                    >
                      {UIHelper.buildCardHeader('Thông tin khác', false, null, true)}
                      <div className="row m-0 p-0 px-2">
                        {/* dia chi */}
                        <div className="col-lg-4 mb-4 px-2">
                          <div className="d-flex gap-3 flex-wrap">
                            {/* tinh/thanh pho */}
                            <div className="flex-grow-1">
                              {UIHelper.buildFormLabel('Tỉnh/Thành phố', true)}
                              <KTBSDropdown
                                name="province"
                                direction={KTBSDropdownDirections.up}
                                toggleElement={
                                  <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedAreaProvince && readyToValidData
                                      ? 'button-invalid'
                                      : ''
                                      }`}
                                    type="button"
                                  >
                                    {selectedAreaProvince?.name ?? 'Chọn tỉnh/thành phố'}
                                  </button>
                                }
                                selectedValue={selectedAreaProvince?.areaId}
                                dropdownMenuItems={areaProvinceOptions}
                                dropdownMenuClassName="overflow-auto w-100"
                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                onChange={(value) => {
                                  setSelectedAreaProvince(
                                    _.find(areaProvinceList, (item) => item.areaId === value)
                                  );
                                  setSelectedAreaDistrict(null);
                                }}
                                isDropdownForm={true}
                                searchable
                                liveSearch={false}
                                onTextChanged={(text) => { }}
                              />
                            </div>
                            {/* quan/huyen */}
                            <div className="flex-grow-1">
                              {UIHelper.buildFormLabel('Phường/Xã', true)}
                              <KTBSDropdown
                                name="district"
                                direction={KTBSDropdownDirections.up}
                                toggleElement={
                                  <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedAreaDistrict && readyToValidData
                                      ? 'button-invalid'
                                      : ''
                                      }`}
                                    type="button"
                                  >
                                    {selectedAreaDistrict?.name ?? 'Chọn phường/xã'}
                                  </button>
                                }
                                selectedValue={selectedAreaDistrict?.areaId}
                                dropdownMenuItems={areaDistrictOptions}
                                dropdownMenuClassName="overflow-auto w-100"
                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                onChange={(value) => {
                                  const area = _.find(
                                    areaDistrictList,
                                    (item) => item.areaId === value
                                  );
                                  setSelectedAreaDistrict(area);
                                  formikProps.setFieldValue('areaId', area?.areaId);
                                  setCoordinates(`${area?.latitude}, ${area?.longitude}`);
                                }}
                                isDropdownForm={true}
                                searchable
                                liveSearch={false}
                                onTextChanged={(text) => { }}
                              />
                            </div>
                          </div>
                          {/* dia chi */}
                          <div className="mt-4">
                            {UIHelper.buildFormLabel('Địa chỉ cụ thể', true)}
                            <FastField name="address">
                              {({ field, form, meta }) => (
                                <KTFormInput
                                  type={KTFormInputType.text}
                                  placeholder="Nhập số nhà, tên đường, thôn/xóm"
                                  name={field.name}
                                  value={field.value}
                                  onChange={(value) => {
                                    form.setFieldValue(field.name, value);
                                  }}
                                  onBlur={() => {
                                    form.setFieldTouched(field.name, true);
                                  }}
                                  enableCheckValid={true}
                                  isValid={_.isEmpty(meta.error)}
                                  isTouched={meta.touched}
                                  feedbackText={meta.error}
                                />
                              )}
                            </FastField>
                          </div>
                          {/* toa do */}
                          <div className="mt-4">
                            {UIHelper.buildFormLabel('Toạ độ', true)}
                            <KTFormInput
                              type={KTFormInputType.text}
                              placeholder="Nhập tọa độ: vĩ độ, kinh độ"
                              name="coordinates"
                              value={coordinates}
                              onChange={(value) => {
                                setCoordinates(value);
                              }}
                              onBlur={() => { }}
                              enableCheckValid={readyToValidData}
                              isValid={
                                Utils.isValid(coordinates) &&
                                coordinates?.match(AppConfigs.regex.coordinate)
                              }
                              isTouched={true}
                              feedbackText={
                                !Utils.isValid(coordinates)
                                  ? 'Bạn chưa nhập toạ độ'
                                  : !coordinates?.match(AppConfigs.regex.coordinate)
                                    ? 'Toạ độ không hợp lệ'
                                    : ''
                              }
                            />
                          </div>
                        </div>
                        {/* mo ta */}
                        <div className="col-lg-4 mb-4 px-2">
                          <div>
                            {/* dich vu di kem */}
                            <div className="">
                              <div>
                                {UIHelper.buildFormLabel('Dịch vụ đi kèm')}
                                <TagifyInput
                                  name="services"
                                  placeholder="Nhập dịch vụ đi kèm"
                                  tagifyDataWhiteList={configServices?.map((item) => item.name)}
                                  tagifyDataBlackList={[]}
                                  value={csServices}
                                  onChange={(value) => {
                                    setCsServices(value);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="mt-4">
                              {UIHelper.buildFormLabel('Mô tả')}
                              <FastField name="description">
                                {({ field, form, meta }) => (
                                  <KTFormTextArea
                                    placeholder="Nhập mô tả"
                                    rows={5}
                                    name={field.name}
                                    value={field.value}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                    }}
                                    onBlur={() => {
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid={true}
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                  />
                                )}
                              </FastField>
                            </div>
                          </div>
                        </div>
                        {/* ban do */}
                        <div className="col-lg-4 mb-4 px-2">
                          <div>
                            {UIHelper.buildFormLabel('Hiển thị trên bản đồ')}
                            <div
                              className="h-200px overflow-hidden"
                              style={{
                                borderRadius: '5px',
                              }}
                            >
                              {bingmapEl}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* hinh anh tram sac */}
                    <div
                      className="p-4"
                      style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                      }}
                    >
                      {UIHelper.buildFormLabel('Hình ảnh trạm sạc', false)}
                      <div className="d-flex">
                        <label className="cursor-pointer">
                          {UIHelper.buildNegativeButton(
                            'Tải ảnh lên',
                            () => { },
                            <i className="fa-regular fa-upload" />
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            hidden
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            onChange={handleFilesChanged}
                          />
                        </label>
                      </div>
                      {!_.isEmpty(allFiles) && (
                        <div className="row m-0 p-0">
                          {allFiles.map((item, index) => {
                            return (
                              <div className="p-0 col-2 mb-2 px-2" key={item?.lastModified ?? item ?? index}>
                                <ImageView
                                  name={item?.lastModified ?? item ?? index}
                                  path={_.isString(item) ? item : item?.name}
                                  item={item}
                                  onRemove={() => {
                                    handleRemoveFile(item);
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    {/* thong tin dien luc */}
                    <div className="radio-inline w-100">
                      <div className='d-flex align-items-center gap-5'>
                        {UIHelper.buildCardHeader('Giá điện mua vào', false, null, true)}
                        <FastField name="inputPricingMode">
                          {({ field, form, meta }) => (
                            <div className='d-flex gap-5'>
                              <KTRadio
                                name={field.name + 'HOURS'}
                                label="Theo khung giờ"
                                type={KTRadioType.outline}
                                additionalClassName="radio-success mb-0"
                                onChange={(value) => {
                                  form.setFieldValue(field.name, 'HOURS');
                                }}
                                checked={field.value == 'HOURS'}
                              // disabled={editMode || !canChangeProductType}
                              />
                              <KTRadio
                                name={field.name + 'TIERED'}
                                label="Theo bậc thang"
                                type={KTRadioType.outline}
                                additionalClassName="radio-success mb-0"
                                onChange={(value) => {
                                  form.setFieldValue(field.name, 'TIERED');
                                }}
                                checked={field.value == 'TIERED'}
                              // disabled={editMode || !canChangeProductType}
                              />
                              <KTRadio
                                name={field.name + 'FLAT'}
                                label="Đồng giá"
                                type={KTRadioType.outline}
                                additionalClassName="radio-success mb-0"
                                onChange={(value) => {
                                  form.setFieldValue(field.name, 'FLAT');
                                }}
                                checked={field.value == 'FLAT'}
                              // disabled={editMode || !canChangeProductType}
                              />
                            </div>
                          )}
                        </FastField>
                      </div>
                    </div>
                    <div
                      className="row m-0 p-0 px-2"
                      style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }}
                    >
                      {/* doi tuong thanh toan tien dien */}
                      <div className="col-lg-4 mb-4 px-2">
                        {UIHelper.buildFormLabel('Đối tượng thanh toán tiền điện', true)}
                        <Field name="isAgencyPayEnergyCost">
                          {({ field, form, meta }) => {
                            return (
                              <KTBSDropdown
                                name="isAgencyPayEnergyCost"
                                toggleElement={
                                  <button
                                    className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!field?.value && readyToValidData ? 'button-invalid' : ''}`}
                                    type="button"
                                  >
                                    {_.find(
                                      ChargeHelper.Data.electricityPayerOptions(selectedManagementObject),
                                      (item) => Number(item.value) === Number(field.value)
                                    )?.name ?? 'Chọn đối tượng thanh toán'}
                                  </button>
                                }
                                selectedValue={field.value}
                                dropdownMenuItems={ChargeHelper.Data.electricityPayerOptions(selectedManagementObject)}
                                dropdownMenuClassName="overflow-auto w-100"
                                dropdownMenuStyle={{ maxHeight: '30vh' }}
                                onChange={(value) => {
                                  form.setFieldValue(field.name, value);
                                }}
                                isDropdownForm={true}
                              />
                            )
                          }}
                        </Field>
                      </div>
                      {/* gia dien dong gia */}
                      {formikProps.values.inputPricingMode === 'FLAT' && (
                        <div className="col-lg-4 mb-4 px-2">
                          <div>
                            {UIHelper.buildFormLabel('Giá điện cố định', true)}
                            <FastField name="inputFlatPrice">
                              {({ field, form, meta }) => (
                                <KTFormInput
                                  type={KTFormInputType.currency}
                                  unit="VNĐ/kWh"
                                  placeholder="Nhập giá điện cố định"
                                  name={field.name}
                                  value={field.value}
                                  onChange={(value) => {
                                    form.setFieldValue(field.name, value);
                                  }}
                                  onBlur={() => {
                                    form.setFieldTouched(field.name, true);
                                  }}
                                  enableCheckValid={true}
                                  isValid={_.isEmpty(meta.error)}
                                  isTouched={meta.touched}
                                  feedbackText={meta.error}
                                />
                              )}
                            </FastField>
                          </div>
                        </div>
                      )}

                      {/* gia dien theo gio */}
                      {formikProps.values.inputPricingMode === 'HOURS' && (
                        <div className='row m-0 p-0'>
                          <div className="col-lg-4 mb-4 px-2">
                            <div>
                              <div className='d-flex gap-2'>
                                {UIHelper.buildFormLabel('Giá điện giờ bình thường', true, false)}
                                <KTTooltip
                                  text={`<div><div>• Từ thứ 2 đến thứ 7: 04:00 - 09:30, 11:30 - 17:00, 20:00 - 22:00</div><div>• Chủ nhật: 04:00 - 22:00</div></div>`}
                                  textHeader="Giờ bình thường"
                                  isHtmlContent
                                >
                                  <i
                                    className="fa-regular fa-info-circle"
                                    style={{ color: AppColors.info }}
                                  />
                                </KTTooltip>
                              </div>
                              <FastField name="inputNormalPrice">
                                {({ field, form, meta }) => (
                                  <KTFormInput
                                    type={KTFormInputType.currency}
                                    unit="VNĐ/kWh"
                                    placeholder="Nhập giá điện giờ bình thường"
                                    name={field.name}
                                    value={field.value}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                    }}
                                    onBlur={() => {
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid={true}
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                  />
                                )}
                              </FastField>
                            </div>
                          </div>
                          <div className="col-lg-4 mb-4 px-2">
                            <div>
                              <div className='d-flex gap-2'>
                                {UIHelper.buildFormLabel('Giá điện giờ cao điểm', true, false)}
                                <KTTooltip
                                  text={`<div><div>• Từ thứ 2 đến thứ 7: 09:30 - 11:30, 17:00 - 20:00</div><div>• Chủ nhật: không có</div></div>`}
                                  textHeader="Giờ cao điểm"
                                  isHtmlContent
                                >
                                  <i
                                    className="fa-regular fa-info-circle"
                                    style={{ color: AppColors.info }}
                                  />
                                </KTTooltip>
                              </div>
                              <FastField name="inputPeakPrice">
                                {({ field, form, meta }) => (
                                  <KTFormInput
                                    type={KTFormInputType.currency}
                                    unit="VNĐ/kWh"
                                    placeholder="Nhập giá điện giờ cao điểm"
                                    name={field.name}
                                    value={field.value}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                    }}
                                    onBlur={() => {
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid={true}
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                  />
                                )}
                              </FastField>
                            </div>
                          </div>
                          <div className="col-lg-4 mb-4 px-2">
                            <div>
                              <div className='d-flex gap-2'>
                                {UIHelper.buildFormLabel('Giá điện giờ thấp điểm', true, false)}
                                <KTTooltip
                                  text={`<div>Từ 22:00 - 04:00 tất cả các ngày trong tuần</div>`}
                                  textHeader="Giờ thấp điểm"
                                  isHtmlContent
                                >
                                  <i
                                    className="fa-regular fa-info-circle"
                                    style={{ color: AppColors.info }}
                                  />
                                </KTTooltip>
                              </div>
                              <FastField name="inputOffPeakPrice">
                                {({ field, form, meta }) => (
                                  <KTFormInput
                                    type={KTFormInputType.currency}
                                    unit="VNĐ/kWh"
                                    placeholder="Nhập giá điện giờ thấp điểm"
                                    name={field.name}
                                    value={field.value}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                    }}
                                    onBlur={() => {
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid={true}
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                  />
                                )}
                              </FastField>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* gia dien bac thang */}
                      {formikProps.values.inputPricingMode === 'TIERED' && (
                        <div className='row m-0 p-0'>
                          {formikProps.values.inputTieredPrice?.map((input, index, array) => {
                            const isLastTier = index === array.length - 1;
                            const prevUpto = index === 0 ? 0 : array[index - 1]?.upto;
                            const currentUpto = input?.upto;

                            return (
                              <div key={`tiered-price-${index}`} className="col-lg-4 mb-4 px-2">
                                <div>
                                  {UIHelper.buildFormLabel(
                                    `Giá điện bậc ${index + 1} (Từ ${prevUpto + 1}${isLastTier ? ' kWh trở lên' : `-${currentUpto} kWh`
                                    })`,
                                    true
                                  )}
                                  <FastField name={`inputTieredPrice[${index}].price`}>
                                    {({ field, form, meta }) => (
                                      <KTFormInput
                                        type={KTFormInputType.currency}
                                        unit="VNĐ/kWh"
                                        placeholder="Nhập số tiền"
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => form.setFieldValue(field.name, value)}
                                        onBlur={() => form.setFieldTouched(field.name, true)}
                                        enableCheckValid
                                        isValid={!meta.error}
                                        isTouched={meta.touched}
                                        feedbackText={meta.error}
                                      />
                                    )}
                                  </FastField>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    {/* danh sach tai khoan dien luc */}
                    {UIHelper.buildCardHeader('Tài khoản điện lực', false, null, true)}
                    <div className="d-flex flex-column">
                      {energyAccountList.map((item, index) => {
                        return (
                          <div className="d-flex align-items-end" key={`ENERGY_ACCOUNT_${index}`}>
                            <div className="row m-0 p-0 px-2 flex-grow-1">
                              <div className="col-sm-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Mã khách hàng (mã tài khoản điện lực)', true)}
                                <KTFormInput
                                  name={`ENERGY_ACCOUNT_${index}_ID`}
                                  type={KTFormInputType.text}
                                  placeholder="Nhập mã tài khoản"
                                  value={item.evnCustomerId}
                                  onChange={(value) => {
                                    const newEnergyAccountList = [...energyAccountList];
                                    newEnergyAccountList[index].evnCustomerId = value;
                                    setEnergyAccountList(newEnergyAccountList);
                                  }}
                                  enableCheckValid={readyToValidData}
                                  isTouched={readyToValidData}
                                  isValid={Utils.isValid(item.evnCustomerId)}
                                  feedbackText={!Utils.isValid(item.evnCustomerId) ? 'Vui lòng nhập mã khách hàng' : ''}
                                />
                              </div>
                              <div className="col-sm-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Tên đăng nhập', true)}
                                <KTFormInput
                                  name={`ENERGY_ACCOUNT_${index}_USERNAME`}
                                  type={KTFormInputType.text}
                                  placeholder="Nhập tên đăng nhập"
                                  value={item.username}
                                  onChange={(value) => {
                                    const newEnergyAccountList = [...energyAccountList];
                                    newEnergyAccountList[index].username = value;
                                    setEnergyAccountList(newEnergyAccountList);
                                  }}
                                  enableCheckValid={readyToValidData}
                                  isTouched={readyToValidData}
                                  isValid={Utils.isValid(item.username)}
                                  feedbackText={!Utils.isValid(item.username) ? 'Vui lòng nhập tên đăng nhập' : ''}
                                />
                              </div>
                              <div className="col-sm-4 mb-4 px-2">
                                {UIHelper.buildFormLabel('Mật khẩu', true)}
                                <KTFormInput
                                  name={`ENERGY_ACCOUNT_${index}_PASSWORD`}
                                  type={KTFormInputType.text}
                                  placeholder="Nhập mật khẩu"
                                  value={item.password}
                                  onChange={(value) => {
                                    const newEnergyAccountList = [...energyAccountList];
                                    newEnergyAccountList[index].password = value;
                                    setEnergyAccountList(newEnergyAccountList);
                                  }}
                                  enableCheckValid={readyToValidData}
                                  isTouched={readyToValidData}
                                  isValid={Utils.isValid(item.password)}
                                  feedbackText={!Utils.isValid(item.password) ? 'Vui lòng nhập mật khẩu' : ''}
                                />
                              </div>
                            </div>
                            {/* <div className="mr-4 mb-4">
                              {UIHelper.buildNegativeButton(
                                'Xóa',
                                () => {
                                  const newEnergyAccountList = [...energyAccountList];
                                  newEnergyAccountList.splice(index, 1);
                                  setEnergyAccountList(newEnergyAccountList);
                                },
                                <i className="fa-regular fa-trash-can" />
                              )}
                            </div> */}
                          </div>
                        );
                      })}
                      {/* <div className="d-flex px-4 mb-4">
                        {UIHelper.buildNegativeButton(
                          'Thêm tài khoản điện lực',
                          () => {
                            setEnergyAccountList([
                              ...energyAccountList,
                              {
                                energyAccountId: '',
                                username: '',
                                password: '',
                                stationId: '',
                                evnCustomerId: '',
                                status: ChargeConstants.EnergyAccountStatus.PENDING,
                              },
                            ]);
                          },
                          <i className="fa-regular fa-plus" />
                        )}
                      </div> */}
                    </div>
                  </div>
                );
              }}
            </Formik>
          </div>,
          false
        )
        }
      </div >

      {/* footer */}
      < div
        ref={refFooter}
        className="bg-white d-flex align-items-center justify-content-end p-4 gap-3"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        {
          UIHelper.buildNegativeButton('Hủy bỏ', () => {
            router.navigate(-1);
          })
        }
        {
          UIHelper.buildGreenButton(
            'Lưu lại',
            () => {
              // console.log(refFormik.current?.errors);
              setReadyToValidData(true);
              refFormik?.current?.handleSubmit();
            },
            null,
            false,
            loading
          )
        }
      </div >
    </div >
  );
}

export default ChargeStationAddView;
